// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hub-forms-modal__buttons{
    border-top: 1px solid var(--new-input-background-color);
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 11px 18px;
}

.hub-forms-modal__team-info{
    display: flex;
    align-items: center;
    padding: 16px 10px;
    margin: 18px 50px 32px 50px;
    border: 1px solid var(--new-gray-background-color);
    border-radius: 8px;
}

.hub-forms-modal__team-info__name-username{
    margin-left: 10px;
}

.hub-forms-modal__team-info__name-username .baloa-names  {
    color: var(--primary-very-dark-color);
}

.hub-forms-modal__team-info__name-username .baloa-username{
    color: var(--primary-dark-color);
}

.hub-forms-modal__team-info img{
    width: 40px;
    height: 40px;
    border-radius: 50%;
}

.hub-forms-modal__team-info .icon-ball{
    color: var(--white-color);
    font-size: 30px;
    padding: 4px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */
    
    .hub_form_modal_component .modal2__container{
        height: 100vh;
        margin: 0px;
        max-height: 100%;
        border-radius: 0px;
    }

    .hub_form_modal_component .modal2__content {
        height: 100vh;
    }

    .scroll-parent .hub-forms-modal__buttons {    
        /* border-top: none; */
        width: 100%;
        position: absolute;
        bottom: 0;
        padding: 6px 18px;
        background-color: var(--white-color);
    }

    .hub-forms-modal__team-info{
        margin: 16px;
     }
 
}`, "",{"version":3,"sources":["webpack://./src/app/tournaments/components/hub-forms-modal/HubFormsModalComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,uDAAuD;IACvD,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,2BAA2B;IAC3B,kDAAkD;IAClD,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA,yCAAyC,4BAA4B;;IAEjE;QACI,aAAa;QACb,WAAW;QACX,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,sBAAsB;QACtB,WAAW;QACX,kBAAkB;QAClB,SAAS;QACT,iBAAiB;QACjB,oCAAoC;IACxC;;IAEA;QACI,YAAY;KACf;;AAEL","sourcesContent":[".hub-forms-modal__buttons{\n    border-top: 1px solid var(--new-input-background-color);\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    padding: 11px 18px;\n}\n\n.hub-forms-modal__team-info{\n    display: flex;\n    align-items: center;\n    padding: 16px 10px;\n    margin: 18px 50px 32px 50px;\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 8px;\n}\n\n.hub-forms-modal__team-info__name-username{\n    margin-left: 10px;\n}\n\n.hub-forms-modal__team-info__name-username .baloa-names  {\n    color: var(--primary-very-dark-color);\n}\n\n.hub-forms-modal__team-info__name-username .baloa-username{\n    color: var(--primary-dark-color);\n}\n\n.hub-forms-modal__team-info img{\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n}\n\n.hub-forms-modal__team-info .icon-ball{\n    color: var(--white-color);\n    font-size: 30px;\n    padding: 4px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n    \n    .hub_form_modal_component .modal2__container{\n        height: 100vh;\n        margin: 0px;\n        max-height: 100%;\n        border-radius: 0px;\n    }\n\n    .hub_form_modal_component .modal2__content {\n        height: 100vh;\n    }\n\n    .scroll-parent .hub-forms-modal__buttons {    \n        /* border-top: none; */\n        width: 100%;\n        position: absolute;\n        bottom: 0;\n        padding: 6px 18px;\n        background-color: var(--white-color);\n    }\n\n    .hub-forms-modal__team-info{\n        margin: 16px;\n     }\n \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
